export const qs = (query, symbol = '') => {
  if (!query) {
    return ''
  }

  let queryString = Object.entries(query).reduce((list, [key, value]) => {
    if (!(value === undefined || value === null || value === '')) {
      list.push([key, encodeURIComponent(value)].join('='))
    }

    return list
  }, []).join('&')

  if (queryString) {
    queryString = symbol + queryString
  }

  return queryString
}



// WEBPACK FOOTER //
// ./src/apis/qs.js